<script>
  import Header from "../components/Header.svelte";
  import { onMount } from "svelte";
  import ProtectedRoute from "../components/ProtectedRoute.svelte";
  import OtpCard from "../components/OtpCard.svelte";
  import Notification from "../components/Notification.svelte";

  let showNotification = false;
  let message = "";
  let notificationType = "";

  let qrCodeImage = null;
  let is2FAEnabled = false;
  let userData = null;
  let showOtpCard = false;

  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
    const saved2FAStatus = userData.user.is2FAEnabled;
    const savedQrCodeImage = localStorage.getItem("qrCodeImage");
    if (saved2FAStatus !== null) {
      is2FAEnabled = saved2FAStatus;
    }
    if (savedQrCodeImage !== null) {
      qrCodeImage = savedQrCodeImage;
    }
  });

  async function toggle2FA() {
    try {
      if (is2FAEnabled) {
        showOtpCard = true;
        return;
      }

      await handleToggle2FA();
    } catch (error) {
      // console.error("Error toggling 2FA:", error);
    }
  }

  async function handleToggle2FA(otp = "") {
    if (otp) {
      const verifyResponse = await fetch(
        "https://api.trulens.ae/api/auth/verify-2fa",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userData.user.email,
            code: otp,
          }),
        }
      );

      const verifyData = await verifyResponse.json();

      if (!verifyResponse.ok) {
        // console.error(verifyData.message);
        message = "Invalid OTP code. 2FA disable failed.";
        showNotification = true;
        notificationType = "danger";
        setTimeout(() => {
          showNotification = false;
        }, 3000);
        // alert("Invalid OTP code. 2FA disable failed.");
        return;
      }
    }

    const response = await fetch("https://api.trulens.ae/api/auth/enable-2fa", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: userData.token,
      },
    });
    const data = await response.json();

    if (response.ok) {
      // console.log(data.message);
      is2FAEnabled = !is2FAEnabled;
      userData.user.is2FAEnabled = is2FAEnabled;
      localStorage.setItem("userData", JSON.stringify(userData));

      qrCodeImage = is2FAEnabled ? data.qrCode : null;
      if (is2FAEnabled) {
      } else {
      }
    } else {
      // console.error(data.error);
    }

    showOtpCard = false;
  }

  function handleOtpSubmit(event) {
    const otp = event.detail;
    handleToggle2FA(otp);
  }

  function handleOtpCancel() {
    showOtpCard = false;
  }
</script>

<ProtectedRoute>
  <Header />
  <Notification {message} show={showNotification} type={notificationType} />
  <div>
    <div class="title">
      <span class="title-span">Two Factor Authentication</span>
    </div>

    <div class="button-container">
      <button type="submit" on:click={toggle2FA}>
        {is2FAEnabled ? "Disable 2FA" : "Enable 2FA"}
      </button>
    </div>

    {#if qrCodeImage}
      <div class="qrcode">
        <img src={qrCodeImage} alt="QR Code for 2FA" />
      </div>
    {/if}

    {#if showOtpCard}
      <OtpCard on:submit={handleOtpSubmit} on:cancel={handleOtpCancel} />
    {/if}
  </div>
</ProtectedRoute>

<style>
  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
  }

  .title-span {
    margin-top: 5px;
    border-radius: 25%;
    padding: 5px;
    font-size: 1.2rem;
    color: #000000;
    font-size: 1.4rem;
    font-weight: bold;
  }

  .button-container {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    left: 0;
  }

  button[type="submit"] {
    width: calc(100% - 85%);
    padding: 10px;
    margin-top: 10px;
    background-color: #ff3c82;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  button[type="submit"]:hover {
    background-color: #b683d4;
  }

  .qrcode {
    display: flex;
    justify-content: center;
    margin-top: 65px;
  }

  .qrcode img {
    width: 300px;
    height: 300px;
    border: 2px solid #b683d4;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    .button-container {
      margin-top: 10px;
    }

    button[type="submit"] {
      width: 50%;
    }

    .qrcode {
      margin-top: 10px;
    }
  }

  @media screen and (min-width: 768px) {
    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {    
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {    
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .title {
      margin-top: 20px;
    }
  }
</style>
